import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import parseFabricMaterial from 'commons/parseFabricMaterial';
import { fabricObject } from '../utils';
const DEFAULT_FABRIC_LIST = [];
const useFabricsPageState = (t0, parseQueryParams, syncStateToUrl, updateQueryParams) => {
  const $ = _c(112);
  const fabricList = t0 === undefined ? DEFAULT_FABRIC_LIST : t0;
  const [selectedFabric, setSelectedFabric] = useState(null);
  const [selectedMaterialType, setSelectedMaterialType] = useState("Fabric");
  const [sortBy, setSortBy] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedColors, setSelectedColors] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [selectedFeatures, setSelectedFeatures] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [selectedTiers, setSelectedTiers] = useState(t3);
  const isInitializedFromParamsRef = useRef(false);
  const skipNextSyncRef = useRef(false);
  let t4;
  if ($[3] !== fabricList) {
    t4 = fabricList.filter(_temp);
    $[3] = fabricList;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const fabricsData = t4;
  let t5;
  if ($[5] !== fabricList) {
    t5 = fabricList.filter(_temp2);
    $[5] = fabricList;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const leathersData = t5;
  let t6;
  let t7;
  if ($[7] !== parseQueryParams) {
    t6 = () => {
      if (isInitializedFromParamsRef.current) {
        return;
      }
      isInitializedFromParamsRef.current = true;
      const params = parseQueryParams();
      if (Object.keys(params).length > 0) {
        if (params.material) {
          setSelectedMaterialType(params.material);
        }
        if (params.sort) {
          setSortBy(params.sort);
        }
        if (params.color && Object.keys(params.color).length > 0) {
          setSelectedColors(params.color);
        }
        if (params.feature && Object.keys(params.feature).length > 0) {
          setSelectedFeatures(params.feature);
        }
        if (params.tier && params.tier.length > 0) {
          setSelectedTiers(params.tier);
        }
      }
    };
    t7 = [parseQueryParams];
    $[7] = parseQueryParams;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  bb0: {
    const materialTypeFiltered = selectedMaterialType === "Fabric" ? fabricsData : leathersData;
    if (selectedMaterialType !== "Fabric") {
      t8 = materialTypeFiltered;
      break bb0;
    }
    let t9;
    if ($[10] !== selectedColors) {
      t9 = Object.keys(selectedColors);
      $[10] = selectedColors;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    const hasSelectedColors = t9.length > 0;
    let t10;
    if ($[12] !== selectedFeatures) {
      t10 = Object.keys(selectedFeatures);
      $[12] = selectedFeatures;
      $[13] = t10;
    } else {
      t10 = $[13];
    }
    const hasSelectedFeatures = t10.length > 0;
    const hasSelectedTiers = selectedTiers.length > 0;
    if (!hasSelectedColors && !hasSelectedFeatures && !hasSelectedTiers) {
      t8 = materialTypeFiltered;
      break bb0;
    }
    let t11;
    if ($[14] !== hasSelectedColors || $[15] !== hasSelectedFeatures || $[16] !== hasSelectedTiers || $[17] !== materialTypeFiltered || $[18] !== selectedColors || $[19] !== selectedFeatures || $[20] !== selectedTiers) {
      let t12;
      if ($[22] !== hasSelectedColors || $[23] !== hasSelectedFeatures || $[24] !== hasSelectedTiers || $[25] !== selectedColors || $[26] !== selectedFeatures || $[27] !== selectedTiers) {
        t12 = fabric => {
          const materials = parseFabricMaterial(fabric.group_material);
          const hasValidColor = !hasSelectedColors || selectedColors[fabric?.option_color];
          const hasValidFeature = !hasSelectedFeatures || (!selectedFeatures.pet_friendly || fabric.pet_friendly === 1) && (!selectedFeatures.velvet || materials.includes("velvet")) && (!selectedFeatures.sustainable_fabric || fabric.sustainable_fabric === 1) && (!selectedFeatures.safeguard || fabric.performance_fabric === 1) && (!selectedFeatures.greenguard_gold || materials.includes("greenguard") || materials.includes("greenguard-gold")) && (!selectedFeatures.pantone || fabric.pantone_flag === 1);
          const hasValidTier = !hasSelectedTiers || selectedTiers.includes(fabric.option_value_tier);
          return hasValidColor && hasValidFeature && hasValidTier;
        };
        $[22] = hasSelectedColors;
        $[23] = hasSelectedFeatures;
        $[24] = hasSelectedTiers;
        $[25] = selectedColors;
        $[26] = selectedFeatures;
        $[27] = selectedTiers;
        $[28] = t12;
      } else {
        t12 = $[28];
      }
      t11 = materialTypeFiltered.filter(t12);
      $[14] = hasSelectedColors;
      $[15] = hasSelectedFeatures;
      $[16] = hasSelectedTiers;
      $[17] = materialTypeFiltered;
      $[18] = selectedColors;
      $[19] = selectedFeatures;
      $[20] = selectedTiers;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    t8 = t11;
  }
  const filteredFabricList = t8;
  let t9;
  bb1: {
    if (!filteredFabricList.length) {
      let t10;
      if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [];
        $[29] = t10;
      } else {
        t10 = $[29];
      }
      t9 = t10;
      break bb1;
    }
    let t10;
    if ($[30] !== filteredFabricList) {
      t10 = filteredFabricList.map(_temp3);
      $[30] = filteredFabricList;
      $[31] = t10;
    } else {
      t10 = $[31];
    }
    t9 = t10;
  }
  const fabricObjects = t9;
  let t10;
  bb2: {
    if (!fabricObjects.length > 0) {
      t10 = null;
      break bb2;
    }
    let t11;
    if ($[32] !== parseQueryParams) {
      t11 = parseQueryParams();
      $[32] = parseQueryParams;
      $[33] = t11;
    } else {
      t11 = $[33];
    }
    const params_0 = t11;
    if (params_0.fabric) {
      let t12;
      if ($[34] !== fabricObjects || $[35] !== params_0.fabric) {
        let t13;
        if ($[37] !== params_0.fabric) {
          t13 = fabric_1 => fabric_1?.footerTitle?.name.trim() === params_0.fabric;
          $[37] = params_0.fabric;
          $[38] = t13;
        } else {
          t13 = $[38];
        }
        t12 = fabricObjects.find(t13);
        $[34] = fabricObjects;
        $[35] = params_0.fabric;
        $[36] = t12;
      } else {
        t12 = $[36];
      }
      const matchedFabric = t12;
      t10 = matchedFabric || null;
      break bb2;
    }
    t10 = null;
  }
  const initialSelectedFabric = t10;
  let t11;
  let t12;
  if ($[39] !== initialSelectedFabric) {
    t11 = () => {
      if (initialSelectedFabric) {
        setSelectedFabric(prev => {
          if (!prev || prev?.footerTitle?.name !== initialSelectedFabric?.footerTitle?.name) {
            skipNextSyncRef.current = true;
            return initialSelectedFabric;
          }
          return prev;
        });
      }
    };
    t12 = [initialSelectedFabric];
    $[39] = initialSelectedFabric;
    $[40] = t11;
    $[41] = t12;
  } else {
    t11 = $[40];
    t12 = $[41];
  }
  useEffect(t11, t12);
  let t13;
  if ($[42] !== selectedFabric?.footerTitle?.name) {
    t13 = () => selectedFabric?.footerTitle?.name || null;
    $[42] = selectedFabric?.footerTitle?.name;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  selectedFabric?.footerTitle?.name;
  let t14;
  if ($[44] !== t13) {
    t14 = t13();
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  const selectedFabricKey = t14;
  let t15;
  if ($[46] !== selectedColors || $[47] !== selectedFabric || $[48] !== selectedFeatures || $[49] !== selectedMaterialType || $[50] !== selectedTiers || $[51] !== sortBy || $[52] !== syncStateToUrl) {
    t15 = () => {
      if (!isInitializedFromParamsRef.current) {
        return;
      }
      if (skipNextSyncRef.current) {
        skipNextSyncRef.current = false;
        return;
      }
      syncStateToUrl({
        selectedMaterialType,
        sortBy,
        selectedColors,
        selectedFeatures,
        selectedTiers,
        selectedFabric
      });
    };
    $[46] = selectedColors;
    $[47] = selectedFabric;
    $[48] = selectedFeatures;
    $[49] = selectedMaterialType;
    $[50] = selectedTiers;
    $[51] = sortBy;
    $[52] = syncStateToUrl;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== selectedColors || $[55] !== selectedFabric || $[56] !== selectedFabricKey || $[57] !== selectedFeatures || $[58] !== selectedMaterialType || $[59] !== selectedTiers || $[60] !== sortBy || $[61] !== syncStateToUrl) {
    t16 = [syncStateToUrl, selectedMaterialType, sortBy, selectedColors, selectedFeatures, selectedTiers, selectedFabricKey, selectedFabric];
    $[54] = selectedColors;
    $[55] = selectedFabric;
    $[56] = selectedFabricKey;
    $[57] = selectedFeatures;
    $[58] = selectedMaterialType;
    $[59] = selectedTiers;
    $[60] = sortBy;
    $[61] = syncStateToUrl;
    $[62] = t16;
  } else {
    t16 = $[62];
  }
  useEffect(t15, t16);
  let t17;
  bb3: {
    if (!fabricObjects.length) {
      let t18;
      if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = {
          byFamily: null,
          byColor: null
        };
        $[63] = t18;
      } else {
        t18 = $[63];
      }
      t17 = t18;
      break bb3;
    }
    let t18;
    if ($[64] !== fabricObjects) {
      t18 = fabricObjects.reduce(_temp4, {
        byFamily: new Map(),
        byColor: new Map()
      });
      $[64] = fabricObjects;
      $[65] = t18;
    } else {
      t18 = $[65];
    }
    t17 = t18;
  }
  const groupedFabrics = t17;
  let t18;
  bb4: {
    if (!fabricObjects.length) {
      let t19;
      if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = [];
        $[66] = t19;
      } else {
        t19 = $[66];
      }
      t18 = t19;
      break bb4;
    }
    if (sortBy === "Family Name" && groupedFabrics.byFamily) {
      let t19;
      if ($[67] !== groupedFabrics.byFamily) {
        t19 = Array.from(groupedFabrics.byFamily.entries()).map(_temp5).sort(_temp6);
        $[67] = groupedFabrics.byFamily;
        $[68] = t19;
      } else {
        t19 = $[68];
      }
      t18 = t19;
      break bb4;
    }
    if (sortBy === "Colors" && groupedFabrics.byColor) {
      let t19;
      if ($[69] !== groupedFabrics.byColor) {
        t19 = Array.from(groupedFabrics.byColor.values()).flat();
        $[69] = groupedFabrics.byColor;
        $[70] = t19;
      } else {
        t19 = $[70];
      }
      t18 = t19;
      break bb4;
    }
    t18 = fabricObjects;
  }
  const displayFabricList = t18;
  let t19;
  if ($[71] !== fabricsData) {
    const colors = fabricsData.reduce(_temp7, []);
    t19 = new Set(colors);
    $[71] = fabricsData;
    $[72] = t19;
  } else {
    t19 = $[72];
  }
  let t20;
  if ($[73] !== t19) {
    t20 = [...t19];
    $[73] = t19;
    $[74] = t20;
  } else {
    t20 = $[74];
  }
  const fabricColors = t20;
  let t21;
  if ($[75] !== fabricsData) {
    const tiers = fabricsData.reduce(_temp8, []);
    t21 = [...new Set(tiers)].sort(_temp9);
    $[75] = fabricsData;
    $[76] = t21;
  } else {
    t21 = $[76];
  }
  const fabricTiers = t21;
  let t22;
  if ($[77] !== selectedColors) {
    t22 = Object.keys(selectedColors);
    $[77] = selectedColors;
    $[78] = t22;
  } else {
    t22 = $[78];
  }
  const colorFilters = t22.length;
  const tierFilters = selectedTiers.length;
  let t23;
  if ($[79] !== selectedFeatures) {
    t23 = Object.keys(selectedFeatures);
    $[79] = selectedFeatures;
    $[80] = t23;
  } else {
    t23 = $[80];
  }
  const featureFilters = t23.length;
  const numberOfActiveFilters = colorFilters + tierFilters + featureFilters;
  let t24;
  if ($[81] !== updateQueryParams) {
    t24 = color_0 => {
      setSelectedColors(prevSelectedColors => {
        const updatedColors = {
          ...prevSelectedColors
        };
        if (updatedColors[color_0]) {
          delete updatedColors[color_0];
        } else {
          updatedColors[color_0] = true;
        }
        const colorKeys = Object.keys(updatedColors).filter(key => updatedColors[key]);
        updateQueryParams("color", null, colorKeys);
        return updatedColors;
      });
    };
    $[81] = updateQueryParams;
    $[82] = t24;
  } else {
    t24 = $[82];
  }
  const toggleSelectedColor = t24;
  let t25;
  if ($[83] !== updateQueryParams) {
    t25 = feature => {
      setSelectedFeatures(prevSelectedFeatures => {
        const updatedFeatures = {
          ...prevSelectedFeatures
        };
        if (updatedFeatures[feature]) {
          delete updatedFeatures[feature];
        } else {
          updatedFeatures[feature] = true;
        }
        const featureKeys = Object.keys(updatedFeatures).filter(key_0 => updatedFeatures[key_0]);
        updateQueryParams("feature", null, featureKeys);
        return updatedFeatures;
      });
    };
    $[83] = updateQueryParams;
    $[84] = t25;
  } else {
    t25 = $[84];
  }
  const toggleSelectedFeature = t25;
  let t26;
  if ($[85] !== updateQueryParams) {
    t26 = tier => {
      setSelectedTiers(prevSelectedTiers => {
        const newTiers = prevSelectedTiers.includes(tier) ? prevSelectedTiers.filter(t => t !== tier) : [...prevSelectedTiers, tier];
        updateQueryParams("tier", null, newTiers.map(_temp10));
        return newTiers;
      });
    };
    $[85] = updateQueryParams;
    $[86] = t26;
  } else {
    t26 = $[86];
  }
  const toggleSelectedTier = t26;
  let t27;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = fabric_5 => {
      setSelectedFabric(fabric_5);
    };
    $[87] = t27;
  } else {
    t27 = $[87];
  }
  const onFabricSelection = t27;
  let t28;
  if ($[88] !== updateQueryParams) {
    t28 = value => {
      setSortBy(value);
      updateQueryParams("sort", value);
    };
    $[88] = updateQueryParams;
    $[89] = t28;
  } else {
    t28 = $[89];
  }
  const handleSetSortBy = t28;
  let t29;
  if ($[90] !== updateQueryParams) {
    t29 = materialType => {
      setSelectedMaterialType(materialType);
      updateQueryParams("material", materialType);
    };
    $[90] = updateQueryParams;
    $[91] = t29;
  } else {
    t29 = $[91];
  }
  const handleMaterialTypeChange = t29;
  let t30;
  if ($[92] !== updateQueryParams) {
    t30 = () => {
      setSelectedColors({});
      setSelectedFeatures({});
      setSelectedTiers([]);
      updateQueryParams("color", null, []);
      updateQueryParams("feature", null, []);
      updateQueryParams("tier", null, []);
    };
    $[92] = updateQueryParams;
    $[93] = t30;
  } else {
    t30 = $[93];
  }
  const clearAllFilters = t30;
  let t31;
  if ($[94] !== clearAllFilters || $[95] !== displayFabricList || $[96] !== fabricColors || $[97] !== fabricTiers || $[98] !== handleMaterialTypeChange || $[99] !== handleSetSortBy || $[100] !== initialSelectedFabric || $[101] !== numberOfActiveFilters || $[102] !== selectedColors || $[103] !== selectedFabric || $[104] !== selectedFeatures || $[105] !== selectedMaterialType || $[106] !== selectedTiers || $[107] !== sortBy || $[108] !== toggleSelectedColor || $[109] !== toggleSelectedFeature || $[110] !== toggleSelectedTier) {
    t31 = {
      initialSelectedFabric,
      selectedMaterialType,
      sortBy,
      selectedColors,
      selectedFeatures,
      selectedTiers,
      selectedFabric,
      fabricColors,
      fabricTiers,
      displayFabricList,
      numberOfActiveFilters,
      handleMaterialTypeChange,
      handleSetSortBy,
      toggleSelectedColor,
      toggleSelectedFeature,
      toggleSelectedTier,
      onFabricSelection,
      clearAllFilters
    };
    $[94] = clearAllFilters;
    $[95] = displayFabricList;
    $[96] = fabricColors;
    $[97] = fabricTiers;
    $[98] = handleMaterialTypeChange;
    $[99] = handleSetSortBy;
    $[100] = initialSelectedFabric;
    $[101] = numberOfActiveFilters;
    $[102] = selectedColors;
    $[103] = selectedFabric;
    $[104] = selectedFeatures;
    $[105] = selectedMaterialType;
    $[106] = selectedTiers;
    $[107] = sortBy;
    $[108] = toggleSelectedColor;
    $[109] = toggleSelectedFeature;
    $[110] = toggleSelectedTier;
    $[111] = t31;
  } else {
    t31 = $[111];
  }
  return t31;
};
export default useFabricsPageState;
function _temp(item) {
  return item.option_name === "Fabric";
}
function _temp2(item_0) {
  return item_0.option_name === "Leather";
}
function _temp3(fabric_0) {
  return fabricObject(fabric_0);
}
function _temp4(acc, fabric_2) {
  const group = fabric_2.option?.group;
  if (group) {
    if (!acc.byFamily.has(group)) {
      acc.byFamily.set(group, []);
    }
    acc.byFamily.get(group).push(fabric_2);
  }
  const color = fabric_2.option?.color;
  if (color) {
    if (!acc.byColor.has(color)) {
      acc.byColor.set(color, []);
    }
    acc.byColor.get(color).push(fabric_2);
  }
  return acc;
}
function _temp5(t0) {
  const [groupName, groupList] = t0;
  return {
    groupName,
    dataSource: groupList,
    groupDesc: groupList[0]?.subTitle?.name || ""
  };
}
function _temp6(a, b) {
  return a.groupName.localeCompare(b.groupName);
}
function _temp7(acc_0, fabric_3) {
  return fabric_3.option_color ? [...acc_0, fabric_3.option_color] : acc_0;
}
function _temp8(acc_1, fabric_4) {
  return fabric_4.option_value_tier ? [...acc_1, fabric_4.option_value_tier] : acc_1;
}
function _temp9(a_0, b_0) {
  return a_0 - b_0;
}
function _temp10(t_0) {
  return t_0.toString();
}